import React, { useState, useContext } from "react";
import "../styles/MobileLogin.css";
import Advert from "./Advert";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import api from "../context/api";

export default function ArkeselLogin() {
  const { phoneNumber, setPhoneNumber } = useContext(AuthContext);
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useState("233");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!phoneNumber) {
      alert("Please enter a valid mobile number.");
      return;
    }

    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber, "GH");

    if (!phoneNumberObj || !phoneNumberObj.isValid()) {
      alert("Invalid Phone Number. Please enter a valid phone number.");
      return;
    }

    const formattedPhoneNumber = phoneNumberObj.format("E.164");

    try {
      setIsLoading(true);
      const response = await api.post("/otp/arkesel/send", {
        phoneNumber: formattedPhoneNumber,
      });

      if (response.data?.code === "0000") {
        navigate("/verify", {
          state: {
            requestId: response.data?.data?.requestId,
            phoneNumber,
            otpLength: response.data?.data?.otpLength || 6,
            provider: "arkesel",
            formattedPhoneNumber,
          },
        });
      } else {
        alert("Failed to send OTP: " + (response.data?.message || "Unknown error"));
      }
    } catch (error) {
      alert(error?.response?.data?.message || "An error occurred while sending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-image-top"></div>
      <div className="login-box">
        <h1>Arkesel OTP Login</h1>
        <p>Use this fallback if MobileLogin (Hubtel) fails.</p>

        <form onSubmit={handleSubmit}>
          <div>Enter Your Phone Number</div>
          <div className="input-group">
            <select
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
            >
              <option value="233">🇬🇭 +233</option>
            </select>
            <input
              type="tel"
              placeholder="Mobile Number (eg 054 099 0099)"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
            />
          </div>

          <button type="submit" disabled={isLoading}>
            {isLoading ? "Processing..." : "Send OTP with Arkesel"}
          </button>
        </form>

        <div className="links">
          <a href="#" onClick={() => navigate("/MobileLogin")}>Back to MobileLogin</a>
          <span>
            having an account? <a href="#" onClick={() => navigate("/login")}>Login</a>
          </span>
        </div>
      </div>
      <div style={{ marginTop: "90px", width: "100%" }}>
        <Advert />
      </div>
    </div>
  );
}
